<template>
        <section>
            <div class="container">
                <div class="my-lg-5 my-4">
                    <img src="https://cdn.studiesweekly.com/store/productpage-ext_15.jpg" class="img-fluid">
                </div>

                <div class="my-lg-5 my-4">
                    <h4>Studies Weekly Online Access Features</h4>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <font-awesome-icon :icon="['far', 'check']" class="text-success" fixed-width /> Student and Teacher materials available online
                         </li>
                        <li class="list-group-item">
                            <font-awesome-icon :icon="['far', 'check']" class="text-success" fixed-width /> All articles have read-aloud features
                         </li>
                        <li class="list-group-item">
                            <font-awesome-icon :icon="['far', 'check']" class="text-success" fixed-width /> More than 3,200 primary and secondary sources
                         </li>
                        <li class="list-group-item">
                            <font-awesome-icon :icon="['far', 'check']" class="text-success" fixed-width /> Lesson plan suggestions are also available
                         </li>
                    </ul>
                </div>

                <div class="my-lg-5 my-4">

                    <h4>Powerful Online Tools</h4>

                    <div>
                        <b-tabs content-class="mt-3">
                            <b-tab title="Online, Customizable Assessments" active>
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="auto" src="https://www.youtube.com/embed/JrkUZscxHkE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                            <b-tab title="Related Media">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="autto" src="https://www.youtube.com/embed/KkaTaxSa54Q" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                            <b-tab title="Annotative Text and Highlighting Tool">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="autto" src="https://www.youtube.com/embed/_Bnn4uMVp7I" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </section>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
